export default __webpack_public_path__ + "static/media/bookmark.43e890b1.PNG";